"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEventTypesSortToJSON = exports.GetEventTypesSortFromJSONTyped = exports.GetEventTypesSortFromJSON = exports.GetEventTypesSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetEventTypesSort;
(function (GetEventTypesSort) {
    GetEventTypesSort["CreatedAt"] = "createdAt";
})(GetEventTypesSort = exports.GetEventTypesSort || (exports.GetEventTypesSort = {}));
function GetEventTypesSortFromJSON(json) {
    return GetEventTypesSortFromJSONTyped(json, false);
}
exports.GetEventTypesSortFromJSON = GetEventTypesSortFromJSON;
function GetEventTypesSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetEventTypesSortFromJSONTyped = GetEventTypesSortFromJSONTyped;
function GetEventTypesSortToJSON(value) {
    return value;
}
exports.GetEventTypesSortToJSON = GetEventTypesSortToJSON;
